/* --- File: src/utils/roles.js ---
   Helper dùng chung xử lý vai trò người dùng — hỗ trợ 1 người có NHIỀU vai trò
   cùng lúc (VD: vừa admin vừa giáo viên).

   Tương thích ngược: user cũ trong Firestore có field `role` (chuỗi đơn, VD:
   "teacher") vẫn hoạt động bình thường — không cần migrate dữ liệu ngay lập
   tức. User mới/đã cập nhật dùng field `roles` (mảng, VD: ["teacher","admin"]).
*/

// Chuẩn hoá vai trò của 1 user thành MẢNG, bất kể dữ liệu gốc là dạng cũ hay mới.
export const getRoles = (userInfo) => {
  if (!userInfo) return [];
  const normalize = value => (Array.isArray(value) ? value : [value])
    .filter(role => typeof role === 'string')
    .map(role => role.trim()).filter(Boolean);
  const roles = normalize(userInfo.roles);
  return [...new Set(roles.length ? roles : normalize(userInfo.role))];
};

// Kiểm tra user có ÍT NHẤT 1 trong các vai trò cần kiểm tra hay không.
// checkRoles có thể là 1 chuỗi ("teacher") hoặc mảng (["admin","teacher"]).
// Dùng thay cho kiểu so sánh cũ: userRole === 'teacher' hoặc
// ['admin','teacher'].includes(userRole)
export const hasRole = (userInfo, checkRoles) => {
  const userRoles = getRoles(userInfo);
  const targets = Array.isArray(checkRoles) ? checkRoles : [checkRoles];
  return userRoles.some(r => targets.includes(r));
};

// Vai trò "chính" để HIỂN THỊ khi chỉ cần show 1 nhãn duy nhất (VD: badge tên
// vai trò trên avatar) — ưu tiên theo thứ tự: admin > teacher > parent > student.
const ROLE_PRIORITY = ['admin', 'teacher', 'parent', 'student'];
export const getPrimaryRole = (userInfo) => {
  const roles = getRoles(userInfo);
  for (const r of ROLE_PRIORITY) {
    if (roles.includes(r)) return r;
  }
  return roles[0] || null;
};

// Nhãn tiếng Việt cho từng vai trò — dùng chung cho mọi nơi hiển thị.
export const ROLE_LABELS = {
  admin: 'Quản trị viên',
  teacher: 'Giáo viên',
  student: 'Học sinh',
  parent: 'Phụ huynh',
};

export const ALL_ROLES = ['admin', 'teacher', 'student', 'parent'];